@if (field.sequentialView && isLanding) {
  <div class="common-text-input__container-field-sequential">
    <field-sequential-header [field]="field"></field-sequential-header>
    <rich-editor [tinyMceOptions]="fieldTypeRichText.tinyMceOptions"
      [modelText]="fieldTypeRichText.inputText"
      [field]="field"
      (emitValue)="modifyField($event)">
    </rich-editor>
    @if(field.error){
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      </div>
    }
  </div>
}@else {
  <div class="common-text-input__container"
    [id]="field.id">
    <div class="common-text-editor__container-box"
        [ngClass]="{'common-text-input__container-box--error': field.error}"
        [attr.disabled]="field.noEditable?true:null"
        [id]="'container-box-'+fieldTypeRichText.tinyMceOptions.id">
        <div class="common-text-input__block-header">
          <label class="common-text-input__label">
            <span class="common-text-input__text-label">{{fieldTypeRichText.titleField}}</span>
            @if (field.required) {
              <span class="common-tag__mandatory-text-asterisk">*</span>
            }
            <div class="common-text-input__block-buttons">
              @if (!textDescription && field.description) {
                <tooltip-info [description]="field.description"
                [field]="field"></tooltip-info>
              }
              @if (field.references?.length) {
                <tooltip-law [references]="field.references"
                [field]="field"></tooltip-law>
              }
              @if (field.relatedInfo?.length) {
                <button class="common-button__icon-sm-noborder"
                  pTooltip="{{'common.related-info'| afTranslate}}"
                  tooltipPosition="top"
                  (click)="openModalRelatedInfo(field.relatedInfo, $event)">
                  <i class="lf-icon-search-text common-icon__md"></i>
                </button>
              }
              @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
                <tooltip-in-report [inReport]="fieldTypeRichText.inReport"></tooltip-in-report>
              }
            </div>
          </label>
          <div class="common-text-input__buttons-right-header">
          @if(field.isVoiceRecord && (skin === 'dark-blue' || skin === 'gm-law')){
            <button class="common-button__icon-sm-noborder"
              [ngClass]="{'common-button__icon-sm-noborder--disabled':field.noEditable}"
              [disabled]="field.noEditable"
              (click)="openRecordVoice()">
              <i class="lf-icon-microphone common-icon__md"></i>
            </button>
          }
          <button class="common-button__icon-sm-noborder"
            (click)="openTextareaModal()">
            <i class="lf-icon-expand common-icon__md"></i>
          </button>
        </div>
      </div>
      <rich-editor [tinyMceOptions]="fieldTypeRichText.tinyMceOptions"
        [modelText]="fieldTypeRichText.inputText"
        (emitValue)="modifyField($event)">
      </rich-editor>
      @if(field.noEditable && field.isVoiceRecord && field.evaluatedValue?.bitValue){
        <div class="field-type-text__transcription-block"
          [ngClass]="{'field-type-text__transcription-block--landing':isLanding}">
          <p class="field-type-text__transcription-text"
            [ngClass]="{'field-type-text__transcription-text--landing':isLanding}"
            [afTranslate]="'record-audio-modal.audio-transcription'"></p>
        </div>
      }
      @if(field.analyzeWithSibila && !isLanding){
        <div class="common-text-editor__block-button-sibila">
          <button class="common-button__expand"
            (click)="analyzeWithSibila()">
            <i class="lf-icon-sibila common-special-icon__sibila-md"></i>
            <span class="common-button__expand-label-text"
              [afTranslate]="'field-type-text.sibila'">Analizar con Sibila</span>
          </button>
        </div>
      }
      @if (fieldTypeRichText.hasVoiceRecord) {
          <div class="common-record-audio__field-block">
            <div class="common-record-audio__field-inner-block">
              <i class="lf-icon-sound common-icon__sm"></i>
              <div class="common-record-audio__name-block"
                (click)="audioDownLoad()">
                <span-tooltip class="common-record-audio__name-text"
                  [ngClass]="{'common-record-audio__name-text--disabled':field.noEditable && fieldTypeRichText.acceptAceptation}"
                  [text]="fieldTypeRichText.voiceRecord.name">
                </span-tooltip>
              </div>
              <div class="common-record-audio__player-block"
                [ngClass]="{'field-type-text__audio-block--accept-check': fieldTypeRichText.acceptAceptation && !fieldTypeRichText.loadFromBack}">
                <button class="common-button__icon-sm-noborder"
                  (click)="playRecordVoice()">
                  <i class="common-icon__md"
                    [ngClass]="{'lf-icon-stop' : startAudio && fieldTypeRichText.audioLoaded,
                      'lf-icon-play': !startAudio,
                      'lf-icon-refresh field-type-text__refresh-animation':!startAudio && !fieldTypeRichText.audioLoaded}">
                  </i>
                </button>
                <div class="common-record-audio__player-line common-record-audio__player-line--background">
                  <div class="common-record-audio__player-line common-record-audio__player-line--active"
                    [progressBar]="percentTime">
                  </div>
                </div>
                @if(!field.noEditable){
                  <button class="common-button__icon-sm-noborder"
                    (click)="resetInput()">
                    <i class="lf-icon-trash common-icon__md"></i>
                  </button>
                }
              </div>
            </div>
          </div>
          <div class="common-button__container-typetext-checkbox">
            <div class="common-button__block-typetext-checkbox"
              [ngClass]="{'common-button__block-typetext-checkbox--mandatory':field.errorInAcceptAceptation}">
              <div class="common-button__block-button-md-checkbox">
                <button class="common-button__icon-md-checkbox"
                    [ngClass]="{'common-button__icon-md-checkbox--selected': fieldTypeRichText.acceptAceptation,
                      'common-button__icon-md-checkbox--disabled': field.noEditable && fieldTypeRichText.acceptAceptation}"
                    (click)="acceptAceptationTerms()">
                    <i class="common-icon__md"
                      [ngClass]="fieldTypeRichText.acceptAceptation?'lf-icon-check-full':'lf-icon-box-inactive'"></i>
                </button>
              </div>
              <div class="common-button__block-text-checkbox">
                <span class="common-button__text-checkbox"
                  [ngClass]="{'common-button__text-checkbox--disabled':field.noEditable && fieldTypeRichText.acceptAceptation}">
                  <span>{{field.voiceRecordOkText}}</span>
                  <span class="common-tag__mandatory-text-asterisk"
                    [ngClass]="{'common-tag__mandatory-text-asterisk--disabled': field.noEditable && fieldTypeRichText.acceptAceptation}">
                    *
                  </span>
                </span>
              </div>
            </div>
            @if (field.errorInAcceptAceptation) {
              <div class="common-button__block-mandatory">
                <span class="common-button__text-mandatory">Obligatorio</span>
              </div>
            }
          </div>
      }
    </div>
    @if(field.error){
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      </div>
    }
  </div>
}
